module.exports = __webpack_public_path__ + "c046b85a462aada52addc07230b85769.svg";